import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/App.css';
import '../css/Cart.css';
import ls from 'local-storage';
import Loading from "./Loading";
import Retry from "./Retry";
import TopNav from "./TopNav";
import OrderProduct from "../Modules/OrderProduct";
import axios from "axios";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class Cart extends React.Component{
    list =[];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            open: false,
            dialogHasConfirm: false,
            total_price: 0,
            retry: false,
            error: false,
            error_text: "",
            dialogText: "",
            dialogTitle: "",
            dialogType: "NONE",
            loading: false,
            buy_list: [],
        };

        this.submitOrder = this.submitOrder.bind(this);
    }



    componentDidMount = () => {
        if(!!ls.get("list")){
            this.list = ls.get("list");
            this.setState({buy_list:this.list},()=>{this.generatePrice()});
        }
        else {
            this.list = [];
            this.setState({buy_list:[]},()=>{this.generatePrice()});
        }

    };
    component
    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        return (
            <div className="App ">
                <Loading loading={this.state.loading}/>
                {this.renderContent()}
            </div>
        );
    }

    renderContent(){
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );

        return (
            <div className="App-body bg-white">
                <TopNav name={"سبد خرید"} productsList={this.state.buy_list} />

                <div className={"content contentCart"} style={{top:"6vh",paddingTop:"3px"}} >
                    {this.renderProducts()}
                </div>
            </div>
        );
    }

    renderProducts = ()=>{
        let dialogConfirm = "";
        if(this.state.dialogHasConfirm)
            dialogConfirm = (
                <Button onClick={this.handleConfirm} color="success" autoFocus>
                    تایید
                </Button>
            );

        if(this.state.buy_list.length === 0)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"} >
                        سبد خرید شما خالی است
                    </div>
                </div>
            );

        return(
            <div>
                <div className={"cartProducts"}>
                    {this.state.buy_list.map((product)=>{
                        let image = product.product_image;
                        if(!image.includes('//asooone.ir') && !image.includes('//Asooone.ir'))
                            image = 'https://asooone.ir/upload/' + image;
                        let index = this.list.findIndex((cart=>cart.product_id === product.product_id));
                        let realPrice = (<span className={"cartPriceNoDis"}/>);
                        if(product.product_discounts > 0)
                            realPrice = (<span className={"cartPriceNoDis"}>{new Intl.NumberFormat("fa").format(product.product_price)}</span>);
                        return (
                            <div key={product.product_id} className={"cartItem"}>
                                <div className={"cartDataRow"}>
                                    <img className={"cartImage"} src={image}/>
                                    <div className={"cartImageSide"}>
                                        <div className={"cartInfo"}>
                                            <span className={"cartProductName"}>{product.product_name}</span>
                                            <span className={"cartStoreName"}>{product.store_name}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={"cartAmountRow"}>
                                    <span className={"cartPrice"}>{new Intl.NumberFormat("fa").format((product.product_price-product.product_discounts))} تومان</span>
                                    {realPrice}

                                    <div className={"cartBuy"}>
                                        <button className={"cart add_amount"}  onClick={()=>this.addProductToList(product.product_id)} >+</button>
                                        <label className={"cart amount"}>{this.state.buy_list[index].product_number + " عدد"}</label>
                                        <button className={"cart sub_amount"}  onClick={()=>this.subProductToList(product.product_id)} >-</button>
                                    </div>

                                </div>
                            </div>
                        );
                    })}
                </div>

                <button id={"cartSubmitButton"} onClick={()=>{this.submitOrder()}}>
                    تایید سبد خرید ( {this.state.total_price} تومان )
                </button>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.dialogText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            بستن
                        </Button>
                        {dialogConfirm}
                    </DialogActions>
                </Dialog>
            </div>
        )

    };


    addProductToList(id){
        if(this.list  == null)
            this.list  = [];
        let found = this.list.some(el=>el.product_id === id);
        let productIndex = this.state.buy_list.findIndex(product=>product.product_id === id);
        let product_number = this.state.buy_list[productIndex].product_max_number;

        if(!found){
            this.list.push(this.state.buy_list[productIndex]);
            this.list[this.list.length-1].product_number = 1;
        }

        else{
            let index = this.list.findIndex((cart=>cart.product_id === id));
            if(product_number == null || product_number > this.list[index].product_number)
                this.list[index].product_number +=1;
        }

        ls.set("list",this.list);
        this.setState({buy_list:this.list},()=>{this.generatePrice()});
    }
    subProductToList(id){
        let found = this.list.some(el=>el.product_id === id);
        if(found){
            let index = this.list.findIndex((cart=>cart.product_id === id));
            this.list[index].product_number -=1;
            if(this.list[index].product_number <= 0)
                this.list.splice(index,1);
        }

        ls.set("list",this.list);
        this.setState({buy_list:this.list},()=>{this.generatePrice()});
    }
    generatePrice (){
        console.log("listssss : ",this.state.buy_list);
        let price = 0;
        for(let i = 0; i<this.state.buy_list.length;i++)
            price += (this.state.buy_list[i].product_price - this.state.buy_list[i].product_discounts) * this.state.buy_list[i].product_number;

        price = new Intl.NumberFormat("fa").format(price);

        this.setState({total_price:price});

    };
    submitOrder(isAccepted="NONE"){
        this.setState({loading:true});
        let json = [];
        this.state.buy_list.forEach((item,index)=>{
            let object = new OrderProduct(item.product_id,item.product_number);
            json.push(object);
        });

        let data = {
            token:ls.get("token"),
            OrderProducts:JSON.stringify(json),
            isAccepted:isAccepted,
            from_web:1
        };
        axios.post(urls.baseUrl+urls.addOrder,data)
            .then(res => {
                if(res.data.code == 200){
                    ls.set("order_id",res.data.order_id);
                    ls.set("TotalPrice",res.data.TotalPrice);
                    ls.set("TotalPriceWithDiscount",res.data.TotalPriceWithDiscount);
                    this.props.history.push({
                        pathname: '/choose_address',
                    });
                }
                else if(res.data.code == 204){
                    this.setState({
                        open:true,
                        dialogHasConfirm:true,
                        dialogText:res.data.message,
                        dialogTitle:"آیا میخواهید ادامه دهید ؟",
                        dialogType:"RETRY_YES",
                        loading:false,
                    });
                }
                else
                    this.setState({
                        open:true,
                        dialogHasConfirm:false,
                        dialogText:res.data.message,
                        dialogTitle:"امکان ثبت سفارش در زمان کنونی وجود ندارد.",
                        dialogType:"NONE",
                        loading:false,
                    });
            })
            .catch(error =>{
                this.setState({
                    open:true,
                    dialogHasConfirm:false,
                    dialogText:error.toString(),
                    dialogTitle:"خطای برقراری ارتباط با سرور.",
                    dialogType:"NONE",
                    loading:false,
                });
            })
    };






    handleClose  = () => {
        this.setState({open:false})
    };
    handleConfirm  = () => {
        this.setState({
            open:false,
        });
        switch (this.state.dialogType) {
            case "RETRY_YES" :
                this.submitOrder("YES");
                break;


            case "NONE":
            default: break;
        }
    };
}



export default Cart;
